import 'swiper/css';
import swal from 'sweetalert';
import 'swiper/css/pagination';
import Cookies from 'js-cookie';
import Swiper, { Autoplay, Pagination } from 'swiper';
import { get_cart_item_count } from '../cart/_cart';
import { toggle_loader } from '../_loader';

document.addEventListener("DOMContentLoaded", function() {

	//if this is NOT on the cart
	if(!this.body.classList.contains('page-template-page-cart')) {

		//update all fulfillment options on the page if we have a cookie that's not default
		apply_fulfilment_to_results();
	}

	let multiple_offers_banner = document.getElementsByClassName('multiple-offers-swiper');

	if(multiple_offers_banner && multiple_offers_banner.length > 0) {

		for(let i = 0; i < multiple_offers_banner.length; i++) {

			new Swiper(multiple_offers_banner[i] , {
				modules: [Pagination],
				autoHeight: true,
				loop: true,
				pagination: {
					el: '.multiple-offers-swiper-pagination',
					type: 'bullets',
					clickable: true
				},
				slidesPerView: 1
			});

		}

	}



	//add an on change event listener (radio button)
	document.addEventListener("change", function(e) {

		//only run if this is a fulfillment toggle
		if(e.target.classList.contains('fulfilment-type-toggle')) {

			let purchase_sidebar = document.getElementById('purchase-sidebar');

			//grab the chosen fulfillment_type
			let fulfillment_type = e.target.value;

            //fetch the total number of items in the cart
            let cart_items = get_cart_item_count();

            //attempt to fetch the contact telephone
            let telephone = document.getElementById('contact-tel');

            //if we're trying to switch to home delivery but it's disabled
            if(cart_items > 0 && fulfillment_type === 'home_delivery' && (tyres_ajax_object.delivery_allowed == 'false')) {

                //create a notification
                swal({
                    title: 'You currently have items in your cart',
                    text: "'Buy Now' online home delivery orders are unavailable. To arrange a delivery, submit a tyre enquiry or call us on 08455214222",
                    timer: 10000
                });
            }

            //if we've been asked to switch to mobile fitting have some items in the cart...
            if(cart_items > 0 && fulfillment_type === 'mobile_fitting') {

                //we intentionally don't update the cookie so these changes don't persist into the basket/checkout

                //create a notification
                swal({
                    title: 'You currently have items in your cart',
                    text: "Sorry, we don't yet support paying for your mobile fitting orders online. Please enquire" + (telephone ? " or call us on " + telephone.dataset.tel : "") + " if you would like to arrange a mobile fitting.",
                    timer: 10000
                });

            } else {

                //set our fulfilment cookie to this value
                Cookies.set('bt_fulfillment_type', fulfillment_type, { expires: 1 });
            }

            //update the body dataset to reflect the new fulfilment type
			document.body.dataset.fulfilment_type = fulfillment_type;

			//update all fulfillment options on the page and calculate quantities
			if(set_fulfillment_type(fulfillment_type, e)) {

                //find the nearest tyre item...
                let tyre_item = (e.target).closest('.tyre-item');

                //check if clicked element is from the top level controls, not the type item, above 1024px.
                if(e.target.classList.contains('top-delivery-toggle') && ! purchase_sidebar.classList.contains('sticky-search')) {
                    let tyre_wrapper = document.getElementById('tyre-results');
                    const mediaQuery = window.matchMedia('(min-width: 1024px)');

                    if(mediaQuery.matches && tyre_wrapper) {
                        const yOffset = -140;
                        const y = tyre_wrapper.getBoundingClientRect().top + window.scrollY + yOffset;
                        window.scrollTo({top: y, behavior: 'smooth'});
                    }
                }

                //if this is a child product...
                if(tyre_item && tyre_item.classList.contains('is-child-display')) {

                    //find the klarna placement
                    let klarna_placement = tyre_item.querySelector('klarna-placement');

                    //if we have a klarna placement
                    if(klarna_placement) {

                        //attempt to fetch the base amount of our tyre
                        let amount = document.querySelector('#tyre-item-child .tyre-item.is-child-display input[name="delivery-type"]:checked').dataset.base_price;

                        //if we have an amount
                        if(amount) {

                            //multiply our base amount by the quantity
                            amount = amount * tyre_item.querySelector('input.qty').value;

                            //save this to the OSM widget
                            klarna_placement.setAttribute('data-purchase-amount', amount);
                        }
                    }
                }
            }

		} else if (e.target.classList.contains('tyre-tab-toggle')) { //otherwise this is a tab for tyre content

			//grab the parent node
			let parent = e.target.parentNode;

			//if we have a valid parent
			if(parent) {

				//if the parent has a tab dataset, this toggle is used for showing content
				if(parent.dataset.tab) {

					//update the tab option here (to toggle the tab change)
					parent.dataset.tab = e.target.value;

					//we don't need the rest of this as it's specific to the price changes
					return;
				}
			}
		}
	});

	document.addEventListener('click', function (event) {

		//if this element is a special offer or a OE product
		if(event.target.classList.contains('special-offer') || event.target.classList.contains('original-equipment')) {

			event.target.classList.toggle('active');
		}
	});

	document.addEventListener('click', function (event) {

		if(event.target.matches('#tab-description-trigger') || event.target.matches('#tab-specification-trigger') || event.target.matches('#tab-technologies-trigger')) {

			let toggles = (event.target.parentNode).getElementsByClassName('tyre-tab-toggles')[0];

			if(toggles) {
				let tab = 'description';

				switch(event.target.id) {
					case 'tab-description-trigger':
						tab = 'description';
						break;
					case 'tab-specification-trigger':
						tab = 'specification';
						break;
					case 'tab-technologies-trigger':
						tab = 'technologies';
						break;
				}

				toggles.dataset.tab = tab;

				(event.target).scrollIntoView();
			}

		}
	});
});

function set_fulfillment_type(fulfillment_type, event = false) {

	//fetch all toggles for all tyres on this page
	let all_toggles = document.getElementsByClassName('delivery-toggles');

	//if we have some toggles
	if(all_toggles) {

        //loop over all toggles
		for(let i = 0; i < all_toggles.length; i++) {

            //grab the parent node
			let parent = all_toggles[i];

            //find the new toggle
			let new_toggle = parent.querySelector('input[value="' + fulfillment_type + '"]');

            //if we have a new toggle
			if(new_toggle) {

                //check the new toggle
				new_toggle.checked = true;
			}

			//if the parent has a tab dataset, this toggle is used for showing content
			if(parent.dataset.tab) {

				//update the tab option here (to toggle the tab change)
				parent.dataset.tab = fulfillment_type;

				//we don't need the rest of this as it's specific to the price changes
				return;
			}

			//update the fulfilment option here (to toggle the price change)
			parent.dataset.fulfilment_option = fulfillment_type;
		}

        //wrapped in a try/catch to account for forcing all prices to be visible
        try {

            //fetch all tyres on the page
            let tyres = document.getElementsByClassName('tyre-item');

            //if we have tyres
            if(tyres && tyres.length > 0) {

                //loop over all tyres
                for(let i = 0; i < tyres.length; i++) {

                    //grab the tyre
                    let tyre = tyres[i];

                    //if this is a fulfillment type toggle
                    if(fulfillment_type == "branch_fitting" || fulfillment_type == "home_delivery" || fulfillment_type == "mobile_fitting") {

                        //figures out whether the user has already modified the quantity indicator
                        let modified = (typeof tyre.dataset.updated != "undefined" && tyre.dataset.updated == "true");

                        //find the matching quantity indicator
                        let quantity = tyre.getElementsByClassName('qty')[0];

                        //if the target value is NOT mobile fitting
                        if(fulfillment_type == 'mobile_fitting') {

                            //if the user modified the quantity but is now underneath our minimum for this type (2) OR it's unmodified and we need to increase it to our minimum
                            if(!modified || modified && parseInt(quantity.value) <= 1) {
                                quantity.value = 2;

                                //if we've had to step in here, switching to another tab would default to our minimum (2), so we'll set update to false and essentially reset
                                tyre.dataset.updated = 'false';
                            }
                        } else if(!modified && quantity) { //otherwise it's delivered or fitted and the user hasn't interacted with it yet
                            quantity.value = 1;
                        }
                    }

                    //identify the buy now button using the parent node's parent
                    let buy_now = tyre.parentNode.getElementsByClassName('buy-now-button')[0];

                    //if we have a buy now button and an associated event
                    if(buy_now && event) {
                        buy_now.href = (buy_now.href).replace(/(fulfilment_option=)[^\&]+/, '$1' + event.target.value);
                    }
                }
            }
        } catch(error) {
            console.log(error);
        }
	}

    //check to see if we have a branch ID in the URL
    let branch_id = window.location.search.includes('branch_id=');

    //if we have a branch ID and this has been triggered by an event
    if(branch_id && event) {

        //show the loader
        toggle_loader(true);

        //check to see if we have a fulfilment option in the URL
        let url_fulfillment = window.location.search.includes('fulfilment_option=');

        //if we have a fulfilment option in the URL
        if(url_fulfillment) {

            //update the URL with the new fulfilment value
            let target_url = (window.location.href).replace(/(fulfilment_option=)[^\&]+/, '$1' + fulfillment_type);

            //remove any offset values (if they exist)
            target_url = target_url.replace(/(offset=)[^\&]+/, '');

            //wait 500ms before updating the URL to allow the loader to show
            setTimeout(() => {

                //update it to the new value
                window.location.href = target_url;

            }, 500);
        }

        //bail
        return false;
    }

    //return true (i.e. continue as normal)
    return true;
}

export default function apply_fulfilment_to_results() {

	//define our default fulfillment type
	let fulfillment_type = false;

    //if the fulfilment type is set in the URL
    if(window.location.search.indexOf('fulfilment_option=') > -1) {

        //grab the fulfilment type from the URL
        fulfillment_type = window.location.search.split('fulfilment_option=')[1].split('&')[0];

        //set the cookie indicating their preference
        Cookies.set('bt_fulfillment_type', fulfillment_type, { expires: 1 });
    } else { //otherwise...

        //attempt to get it from the cookie
        fulfillment_type = Cookies.get('bt_fulfillment_type');
    }

	//if we don't have a fulfilment type
	if(!fulfillment_type) {

		//set the default to fitted
		fulfillment_type = (tyres_ajax_object.delivery_allowed == 'true') ? 'home_delivery' : 'branch_fitting';

		//set the cookie indicating their preference
		Cookies.set('bt_fulfillment_type', fulfillment_type, { expires: 1 });
	}

	//if we have a fulfillment type and it isn't set to the default (fitted)
	if(fulfillment_type) {

		//apply our selection to all types
		set_fulfillment_type(fulfillment_type);
	}
};